import { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import LinkRoute from "../linkRoute/LinkRoute";
import { debounce } from "../../../utils/helperServices";
import styles from "./ContentSearchBox.module.scss";
import axios from "axios";
import * as Analytics from "../../../services/analyticsUtag";
const analyticsTags = [
  "page_name",
  "page_channel",
  "page_master_tab",
  "visitor_login_status",
  "visitor_customer_id",
  "visitor_id_hash",
  "visitor_msisdn_hash",
  "visitor_subscription_type",
];
const ContentSearchBox = (props) => {
  const [searchText, setSearchText] = useState("");
  const [display, setDisplay] = useState(false);
  const [inputClass, setInputClass] = useState("");
  const [filterCategories, setFilterCategories] = useState([]);
  const [displayAddress, setDisplayAddress] = useState(false);
  const [addressSelection, setAddressSelection] = useState(props.isStoreSearch);
  const [filteredAddressData, setFilteredAddressData] = useState([]);
  const config = require("../../../config/index");
  const env = config.env;
  const shoppingUrlPrefix = config.envConfigs[env].shoppingUrlPrefix;
  const searchTextSize = props?.variant == "address-search" ? 3 : 1;

  const handleKeyUp = async (e) => {
    if (
      props.variant == "address-search" &&
      props.pageName &&
      props.analyticFormName &&
      searchText.length === 1
    ) {
      setAnalyticsOnSearch();
    }

    if (searchText.length > searchTextSize) {
      setDisplay(true);
      debounceSearch(props.variant, searchText);
      setInputClass(styles["output-display"]);
      if (e.keyCode == 13) {
        if (props.passSuggestedData) {
          props.passSuggestedData(filteredAddressData);
        }
      }
    } else {
      setDisplay(false);
      setInputClass("");
    }
  };

  const debounceSearch = useCallback(
    debounce((type, sText) => {
      if (type == "address-search" || type == "store-search") {
        getFilteredAddress(sText);
      } else {
        getFilterCategories(sText);
      }
    }, 500),
    []
  );

  /**
   * Set the analytics(link)
   *
   * @call form event fire when the customer searches for something
   */
  const setAnalyticsOnSearch = () => {
    Analytics.link({
      ...Analytics.getUtagData(analyticsTags),
      page_form_event: "start",
      page_form_name: `${props.pageName}: ${props.analyticFormName}`,
    });
  };

  const closeDropdown = () => {
    setDisplay(false);
    setInputClass("");
    setDisplayAddress(false);
  };

  const getFilteredAddress = async (sText) => {
    setFilteredAddressData([]);
    const params = {
      ilsGroups: "address_component",
      ilsLocation: sText,
      ilsResultsCount: 15,
    };
    if (sText && sText.length > 3) {
      let opts = {
        method: "GET",
        headers,
        params,
      };
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
      };
      // const url = config.api.addressDev;
      const url = `${config.envConfigs[config.env].dxl.url}${
        config["api"]["addressDev"]
      }`;
      axios.get(url, opts).then((response) => {
        let responseGot = response?.data?.result?.data?.result?.results ? response?.data?.result?.data?.result?.results : [];
        setFilteredAddressData(responseGot);
        if (
          response?.data?.result?.data?.result?.results &&
          props.analyticFormName &&
          props.pageName
        ) {
          Analytics.link({
            ...Analytics.getUtagData(analyticsTags),
            page_form_event: "success",
            page_form_name: `${props.pageName}: ${props.analyticFormName}`,
          });
        }
      });
    }
    setDisplayAddress(true);
  };

  const handleSelectAddress = (item) => {
    props.setFinalAddress(item);
    setAddressSelection(true);
    setSearchText(item.formatted_address);
    closeDropdown();
  };

  function formatText(text) {
    if (searchText != "" && text) {
      return getHighlightedText(text);
    }
    return text;
  }

  function getHighlightedText(text) {
    // Split text on highlight term, include term itself into parts, ignore case
    const parts = text.split(new RegExp(`(${searchText})`, "gi"));

    return (
      <span>
        {parts.map((part) =>
          part.toLowerCase() === searchText.toLowerCase() ? <b>{part}</b> : part
        )}
      </span>
    );
  }

  useEffect(() => {
    if (displayAddress) {
      document.addEventListener("mouseup", handleClickOutside);
      return () => {
        // Remove the event listner on component unmounting
        document.removeEventListener("mouseup", handleClickOutside);
      };
    }
  }, [displayAddress]);

  const handleClickOutside = (e) => {
    const container = $("#addr-div");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      closeDropdown();
    }
  };

  function getFilterCategories(sText) {
    var filteredArray = props.content
      .filter((item) =>
        item.subCategories.some(
          (subcat) =>
            subcat.title.toLowerCase().search(sText.toLowerCase()) !== -1
        )
      )
      .map((item) => {
        let newElt = Object.assign({}, item); // copies element
        return newElt.subCategories.filter(
          (subcat) =>
            subcat.title.toLowerCase().search(sText.toLowerCase()) !== -1
        );
      });

    setFilterCategories(filteredArray);
  }

  return (
    <>
      <input
        className={`${styles["search-box-input"]} ${
          props.className
        } ${inputClass} ${styles["icon-" + props.icon]}`}
        type="text"
        onKeyUp={handleKeyUp}
        onFocus={handleKeyUp}
        placeholder={props.placeholderText}
        value={searchText}
        onChange={(event) => setSearchText(event.target.value)}
        id={props.id}
      />
      {/*please keep this code till next pr*/}
      {/* {searchText && props.variant != "store-search" && (
					<Image
						className={"imgClose"}
						img_path={`${imagePrefix}/assets/images/close-copy.svg`}
						img_alt="icon"
						img_width="1.125rem"
						img_height="1.125rem"
						onClick={resetValue}
					/>
			)} */}

      {display && (
        <div className={`${styles["search-output"]} d-flex`}>
          {(filterCategories.length > 0 &&
            filterCategories.map((item, index) =>
              item.map((subitem, index) => (
                <LinkRoute
                  href={`${shoppingUrlPrefix}/terms-and-conditions/[slug]`}
                  as={`${shoppingUrlPrefix}/terms-and-conditions${subitem.url}`}
                  text={formatText(subitem.title)}
                  className={`${styles["search-output__nav-subitem"]}`}
                  key={index}
                ></LinkRoute>
              ))
            )) ||
            (filterCategories.length == 0 &&
              props.variant != "address-search" && props.variant != "store-search" && (
                <span className={styles["no-result"]}>No results found</span>
              ))}
        </div>
      )}

      {displayAddress && searchText.length > 3 && (
        <div
          id={"addr-div"}
          className={`${props.variant !="store-search" ? styles["search-output"] : styles["search-output-store"]} ${props.variant == "store-search" && addressSelection == false ? styles["address-position-container"] : ""} d-flex ${
            filteredAddressData.length > 3 && styles["address-container"]
          }`}
        >
          {(filteredAddressData &&
            filteredAddressData.length > 0 &&
            filteredAddressData.map((item, index) => (
              <div key={index}>
               {props?.variant !="store-search" && ( <div
                className={`${styles["search-output__nav-subitem"]} ${styles["address-search"]}`}
                onClick={() => handleSelectAddress(item)}
                
              >
                  {item.formatted_address}
                </div>
                )}
                {props?.variant == "store-search" && ( <div
                  className={`${styles["search-output__nav-subitem"]} ${styles["address-search"]}`}
                  onClick={() => handleSelectAddress(item)}
                >
                  {formatText(item.formatted_address)}
                </div>
                )}
              </div>
            ))) ||
            (filteredAddressData.length == 0 &&
              props.variant == "address-search" || props.variant == "store-search" && (
                <span className={styles["no-result"]}>No results found</span>
              ))}
        </div>
      )}
    </>
  );
};

ContentSearchBox.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
  placeholderText: PropTypes.string,
  content: PropTypes.array,
  icon: PropTypes.oneOf(["red", "blue"]),
  isStoreSearch: PropTypes.bool
};

ContentSearchBox.defaultProps = {
  text: "",
  className: "",
  placeholderText: "Type here to search",
  content: [],
  icon: "red",
  isStoreSearch: false
};

export default ContentSearchBox;
